module.exports = __webpack_public_path__ + "static/media/sandbox.83ea75f4.svg";